<template>
  <q-item :class="`bg-${color}`">
    <q-item-section avatar>
      <q-icon :class="`text-${iconColor}`" :name="icon" />
    </q-item-section>
    <q-item-section>
      <q-item-label class="text-right text-bold text-lg" :class="`text-${valueColor}`">
        {{ value }}
      </q-item-label>
      <q-item-label caption class="text-right" :class="`text-${labelColor}`">
        {{ label }}
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script>
export default {
  props: {
    icon: String,
    color: String,
    label: String,
    value: [Number, String],
    iconColor: {
      type: String,
      default: 'white'
    },
    labelColor: {
      type: String,
      default: 'white'
    },
    valueColor: {
      type: String,
      default: 'white'
    }
  }
};
</script>

<style>
  .text-lg{
    font-size: 32px;
  }
</style>
